import { RiskLevel } from '@models/assessment';

import { Gender } from 'generated/types';

import type { ReferenceRange } from './types';

const referenceRange: ReferenceRange<RiskLevel> = new Map([
  [
    Gender.male,
    new Map([
      [
        RiskLevel.Low,
        [
          {
            upper: 0.96,
          },
        ],
      ],
      [
        RiskLevel.Medium,
        [
          {
            lower: 0.96,
            upper: 1,
          },
        ],
      ],
      [
        RiskLevel.High,
        [
          {
            lower: 1,
            upper: 2.0,
          },
        ],
      ],
    ]),
  ],
  [
    Gender.female,
    new Map([
      [
        RiskLevel.Low,
        [
          {
            upper: 0.81,
          },
        ],
      ],
      [
        RiskLevel.Medium,
        [
          {
            lower: 0.81,
            upper: 0.86,
          },
        ],
      ],
      [
        RiskLevel.High,
        [
          {
            lower: 0.86,
            upper: 2.0,
          },
        ],
      ],
    ]),
  ],
]);

export default referenceRange;
